import { combineReducers } from "redux";

import icons from "js/react/views/icons/reducers/icons_reducer";
import config from "js/react/views/icons/reducers/config_reducer";

export const reducers = () => {
    return combineReducers({
        icons,
        config
    });
};

export default reducers;
